import React from "react";

import useJobResultData from "hooks/useJobResultData";

import ModelQualitySummary from "./ModelQualitySummary";
import TargetRateChart from "./TargetRateChart";
import VariableFunnel from "./VariableFunnel";

const Charts = ({ outputs, setOutputs }) => {
  const { data: modelQuality, loading: modelQualityLoading } = useJobResultData(
    outputs,
    setOutputs,
    "binary_model_quality"
  );
  const { data: modelVariables, loading: modelVariablesLoading } =
    useJobResultData(outputs, setOutputs, "binary_model_variables");

  return (
    <div className="grid grid-cols-1 gap-4 my-5 lg:grid-cols-2 xl:grid-cols-2">
      <TargetRateChart
        data={modelQuality?.confusion_matrix}
        isLoading={modelQualityLoading}
      />
      <VariableFunnel
        data={modelVariables?.variable_list}
        isLoading={modelVariablesLoading}
      />
      <ModelQualitySummary
        data={modelQuality?.confusion_matrix}
        isLoading={modelQualityLoading}
      />
    </div>
  );
};

export default Charts;
